import { DeleteAtomAlertModal } from './DeleteAtomAlertModal'

export default DeleteAtomAlertModal
